import React, { memo } from 'react';
import { Route, Redirect } from 'react-router-dom';
import {
    inPrivateRoute,
    verifyToken,
    inResetPasswordFormRoute,
    securityCodeExistance
} from '../../../auth/helpers/accessControl';

export default memo(function RouteWithSubRoutes(route) {
    return (
        <Route
            exact={route.exact}
            path={route.path}
            render={props => {
                if (route.hasSetup && props.location.pathname === '/setup') {
                    return <Redirect to="/" />
                }

                if (inPrivateRoute(props.location.pathname)) {
                    const validToken = verifyToken();

                    return (
                        validToken
                            ? <route.component {...props} routes={route.routes} />
                            : <Redirect to="/signin" />
                    );
                }

                if (inResetPasswordFormRoute(props.location.pathname)) {
                    const securityCode = securityCodeExistance();

                    return (
                        securityCode
                            ? <route.component {...props} routes={route.routes} />
                            : <Redirect to="/signin" />
                    );
                }

                return <route.component {...props} routes={route.routes} />;
            }}
        />
    );
});
